import { REDUX_MARKET_TYPES } from './action'

const initialState = {}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case REDUX_MARKET_TYPES.RECENT_ITEM:
      return {
        ...state,
        recentItem: action.payload
      }
    default:
      return state
  }
}
